"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionRing = void 0;
var react_1 = __importStar(require("react"));
var useSelectionState_1 = require("./useSelectionState");
var styles = __importStar(require("./SelectionRing.css"));
var slate_1 = require("slate");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var Resizer_1 = require("./Resizer");
var SyntheticSelection_1 = require("Project/SyntheticSelection");
var slate_react_1 = require("slate-react");
var inversify_react_1 = require("inversify-react");
var Router_1 = __importDefault(require("../Router"));
var EditorTypes_1 = require("../EditorTypes");
var ReactUtils_1 = require("@CommonFrontend/Utils/ReactUtils");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var bubbleRootSelector = "[".concat(styles.ringDataAttribute, "],").concat(styles.interactiveElementSelector);
var getTargetContainer = function (target) {
    var bubbleRoot = target.closest(bubbleRootSelector);
    if (!bubbleRoot) {
        return null;
    }
    return bubbleRoot;
};
exports.SelectionRing = (0, react_1.forwardRef)(function (_a, ref) {
    var _b;
    var element = _a.element, children = _a.children;
    var slate = (0, slate_react_1.useSlate)();
    var editor = (0, inversify_react_1.useInjection)(EditorTypes_1.SlateEditor.$);
    var router = (0, inversify_react_1.useInjection)(Router_1.default);
    var conversionElem = (0, inversify_react_1.useInjection)("conversionElem");
    var widgetSelectionState = (0, useSelectionState_1.useSelectionState)(element).widgetSelectionState;
    var _c = __read((0, react_1.useState)(false), 2), isMouseOverWidget = _c[0], setIsMouseOverWidget = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isMouseOverSelectableRegion = _d[0], setIsMouseOverSelectableRegion = _d[1];
    var setSelection = (0, SyntheticSelection_1.useSelectionStore)().setSelection;
    var ringRef = (0, react_1.useRef)(null);
    var resizerContext = (0, Resizer_1.useResizerContext)();
    var elementConfiguration = (0, EditorWidgetRegistry_1.getGenericConfigByType)(element.type, true);
    var hasShowWidgetOutlineOnHoverTrait = (0, CommonWidgetRegistry_1.hasTrait)({
        widgetType: element.type,
        traitName: "showWidgetOutlineOnHover",
    });
    var mode = resizerContext.resizingEnabled && resizerContext.handleDirections === "corners" ? "hugging" : "outside";
    return (react_1.default.createElement("div", (_b = {}, _b[styles.ringDataAttribute] = true, _b.ref = (0, ReactUtils_1.composeRefs)([ref, ringRef]), _b.className = styles.wrapper({ widgetWidth: elementConfiguration === null || elementConfiguration === void 0 ? void 0 : elementConfiguration.width }), _b.onClick = function (e) {
        if (slate_1.Range.isRange(slate.selection) && slate_1.Range.isExpanded(slate.selection)) {
            return;
        }
        if (getTargetContainer(e.target) !== ringRef.current) {
            return;
        }
        setSelection({
            editor: editor,
            conversionElem: conversionElem,
            router: router,
            path: slate_react_1.ReactEditor.findPath(slate, element),
        });
        slate_react_1.ReactEditor.deselect(slate);
        slate_react_1.ReactEditor.blur(slate);
    }, _b.onMouseOver = function (e) {
        if (hasShowWidgetOutlineOnHoverTrait) {
            setIsMouseOverWidget(true);
        }
        if (getTargetContainer(e.target) !== ringRef.current) {
            return;
        }
        setIsMouseOverSelectableRegion(true);
    }, _b.onMouseOut = function (e) {
        if (hasShowWidgetOutlineOnHoverTrait) {
            setIsMouseOverWidget(false);
        }
        setIsMouseOverSelectableRegion(false);
    }, _b),
        react_1.default.createElement("div", { "data-testid": "selection-ring", onClick: function (e) {
                setSelection({
                    editor: editor,
                    conversionElem: conversionElem,
                    router: router,
                    path: slate_react_1.ReactEditor.findPath(slate, element),
                });
                slate_react_1.ReactEditor.deselect(slate);
                slate_react_1.ReactEditor.blur(slate);
                e.stopPropagation();
            }, className: styles.ring({
                mouseOverWidget: isMouseOverWidget,
                mouseOverSelectableRegion: isMouseOverSelectableRegion,
                selected: ["circle", "around"].includes(widgetSelectionState) ||
                    (resizerContext.resizingEnabled && resizerContext.isResizing),
                mode: mode,
            }), contentEditable: false }, resizerContext.resizingEnabled && (react_1.default.createElement(Resizer_1.ResizeHandles, { show: isMouseOverSelectableRegion || widgetSelectionState === "circle", element: element }))),
        children));
});
exports.SelectionRing.displayName = "SelectionRing";
